import {
  Dropdown,
  DropdownMenuItemType,
  IDropdownOption
} from "office-ui-fabric-react";
import React from "react";
import { AssignGroupingKey } from "../../../../types/types";

export const getOptions = () => {
  const groupingKeys: Array<{ key: AssignGroupingKey; text: string }> = [
    { key: "jobCode", text: "ジョブ別" },
    { key: "inChargeKojinCode", text: "担当別" }
  ];
  return [
    {
      key: "header",
      text: "グルーピング",
      itemType: DropdownMenuItemType.Header
    },
    ...groupingKeys
  ];
};

export interface GroupingSelectDropdownProps {
  selectedGroupingCondition: AssignGroupingKey;
  onGroupingConditionChanged: (key: AssignGroupingKey) => void;
}

/**
 * グルーピング条件選択ドロップダウン
 * @param props
 * @constructor
 */
export const GroupingSelectDropdown = (props: GroupingSelectDropdownProps) => {
  const { selectedGroupingCondition, onGroupingConditionChanged } = props;

  const onChange = (
    e: React.FormEvent<HTMLDivElement>,
    item?: IDropdownOption
  ) => {
    if (item) {
      onGroupingConditionChanged(item.key as AssignGroupingKey);
    }
  };

  return (
    <Dropdown
      defaultSelectedKey={selectedGroupingCondition}
      onChange={onChange}
      options={getOptions()}
      styles={{ dropdown: { width: 120 } }}
    />
  );
};
